import { TenantDto } from '@bo-client/shared/models/tenantDto';
import { ColumnEditorModel } from '@bo-client/shared/dynamic-search-serverside/dynamic-search.model';
import { ColumnState } from 'ag-grid-community';

export class UserBackOfficeSettingsModel {
  selectedTenant: TenantDto = new TenantDto();
  userPreferences: UserPreferenceModel = new UserPreferenceModel();
  listConfigurations: { [key: string]: ColumnEditorModel[] } = {};

  orderRequest: SavedSettingsModel = new SavedSettingsModel();
  installerPass: SavedSettingsModel = new SavedSettingsModel();
  commissioningRequest: SavedSettingsModel = new SavedSettingsModel();
  businessPartner: SavedSettingsModel = new SavedSettingsModel();
  gridRegistration: SavedSettingsModel = new SavedSettingsModel();

  generalPageConfig?: GeneralPageConfigModel = new GeneralPageConfigModel();
  pageConfigs: { [K in PageConfigName]?: PageConfigModel } = {};
}

export class SavedSettingsModel {
  columns: any[] = [];
  filters: any;
  sorts: any[] = [];
}

export class UserPreferenceModel {
  sidenavCollapse = false;
}

export class GeneralPageConfigModel {
  listSize = 20;
}

export const pageNames = [
  'css-user-details',
  'commissioning-request',
  'order-request',
  'users',
  'ui-adaptions',
  'template',
  'admin-installer-pass',
  'connection-change',
  'sync',
  'outbox',
  'location',
  'local-street',
  'grid-registration',
  'feeder-contract',
  'installer-news',
  'marketPrices',
  'change-processes'
] as const;

export type PageConfigName = (typeof pageNames)[number];

export interface PageConfigModel {
  columnState?: ColumnState[];
  filterModel?: { [p: string]: unknown };
  pageVersion?: string;
  customFilters?: CustomFilterModel[];
  [K: string]: any;
}

export interface CustomFilterModel {
  id: number;
  name: string;
  config: {
    columnState: PageConfigModel['columnState'];
    filterModel: PageConfigModel['filterModel'];
  };
}
